import apiClient from './apiClient';

/**
 *
 * @param {Array} userIds
 * @returns {Promise<Array>}
 */

export const getUserDetailsByIds = async (userIds) => {
    try {
        const response = await apiClient.post('/users.php?action=getUserDetails', { userIds });
        return response.data;
    } catch (error) {
        console.error('Errore nel recupero dei dettagli degli utenti:', error);
        throw error;
    }
};